<mat-card-footer>
    <mat-dialog-actions text-align="end">
        <mat-icon mat-dialog-close>close</mat-icon>
    </mat-dialog-actions>
</mat-card-footer>
<mat-divider></mat-divider>
<div class="image-dialog-container">
    <mat-icon (click)="previousImage()">navigate_before</mat-icon>
    <img [src]="images[currentIndex].path" alt="Image {{ images[currentIndex].id }}" class="enlarged-image" height="100%"/>
    <mat-icon  (click)="nextImage()">navigate_next</mat-icon>
</div>